import(/* webpackMode: "eager" */ "/home/runner/work/web-apps/web-apps/apps/action-portal/app/global-error.tsx");
